import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import ArrowButton from "@components/ArrowButton";

import "./style.scss";
import PathContants from "@/routers/pathConstants";

const TechIntroSection_3 = () => {
	const leftRef = useRef<HTMLDivElement | null>(null);
	const rightRef = useRef<HTMLDivElement | null>(null);
	const navigate = useNavigate();
	useEffect(() => {
		if (!leftRef.current || !rightRef.current) return;

		gsap.registerPlugin(ScrollTrigger);
		const startPosition = "20% 60%";
		const endPosition = "70% 50%";
		// 왼쪽: 오버레이 페이드인 (흑백 이미지는 유지)
		const leftOverlay = gsap.to(".tech-intro-section_3 .left .overlay", {
			opacity: 1,
			duration: 2,
			ease: "power2.out",
			scrollTrigger: {
				trigger: leftRef.current!,
				start: startPosition,
				end: endPosition,
				scrub: 1,
			},
		});

		// 오른쪽: 이미지 교체 방식 (그레이 레이어 + 컬러 레이어 페이드인)
		const rightColor = gsap.to(".tech-intro-section_3 .right .right__img--color", {
			opacity: 1,
			duration: 2,
			ease: "power2.out",
			scrollTrigger: {
				trigger: rightRef.current!,
				start: startPosition,
				end: endPosition,
				scrub: 1,
			},
		});

		return () => {
			leftOverlay.kill();
			rightColor.kill();
		};
	}, []);

	const handleGoToBrand = () => {
		navigate(`${PathContants.Brand}#ir-92`);
	};

	return (
		<section className="tech-intro-section_3 end-trigger-2">
			<div className="tech-intro-section_3__content">
				<div className="tech-intro-section_3__panel left" ref={leftRef}>
					<div className="tech-intro-section_3__panel__content">
						<div className="overlay"></div>
						<div className="tech-intro-section_3__panel__content__text">
							<h2 className="title">
								과장을 덮고 <br />
								차이를 더하다
							</h2>
							<ArrowButton
								label="VIEW MORE"
								align="right"
								onClick={handleGoToBrand}
							/>
						</div>
					</div>
				</div>
				<div className="tech-intro-section_3__panel right" ref={rightRef}>
					<div className="right__img right__img--gray" />
					<div className="right__img right__img--color" />
				</div>
			</div>
		</section>
	);
};

export default TechIntroSection_3;
